import React, { useState, useEffect } from "react";
import { Result, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import TopBar from "@/Components/TopBar";
import Navbar from "@/Components/navbar";
import userInfo from "@/Components/user";
import { flows } from "@/services/common";
import emptyImg from "@/assets/icons/empty.svg";
import "@/Pages/Project/View/userView.less";

/** 实时监控对应的项目：展示该项目的流程列表 */
const OBSERVATION_PROJECT_ID = 154;

/** 不显示在列表中的流程 id（仅作为流程 615 的快捷入口） */
const HIDDEN_FLOW_IDS = [618, 619, 620, 621, 622, 623, 624];

const Component = () => {
  const [flowList, setFlowList] = useState<any[]>([]);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();

  //加载该项目下的流程列表
  const loadData = () => {
    setloading(true);
    flows(
      OBSERVATION_PROJECT_ID,
      { page: 1, perPage: 1000 },
      userInfo.access_token
    ).then((r) => {
      const list: any[] = r.data?.data || [];
      // 隐藏作为流程 615 快捷入口的子流程
      setFlowList(list.filter((it) => !HIDDEN_FLOW_IDS.includes(it.id)));
      setloading(false);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  //进入该流程的实时监控画布
  const openFlow = (item: any) => {
    navigate(`/project/home/observation/${item.id}`);
  };

  return (
    <>
      <TopBar title="实时监控" mainContent={<Navbar />} />
      <div className="userViewPage">
        {loading ? (
          <div className="userViewLoading">
            <Spin />
          </div>
        ) : (
          <ul className="flowImgList mt1">
            {flowList.length > 0 ? (
              flowList.map((item: any, index: any) => (
                <li key={index}>
                  <div
                    className="imgInner showSImgborder"
                    onClick={() => openFlow(item)}
                  >
                    <div className="showSImg">
                      <div className="showSImg_inner">
                        {item.thumbnail_url ? (
                          <img src={item.thumbnail_url} alt="" />
                        ) : (
                          <div className="nopic">
                            <div>
                              <img
                                src={emptyImg}
                                alt=""
                                style={{ height: "auto", width: "auto" }}
                              />
                              <div className="notext">暂无封面</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="showFname">
                    <div className="sp_left">
                      <div className="sp_name">{item.name}</div>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <div className="userFlowEmpty">
                <Result
                  status="info"
                  title={
                    <div className="userFlowEmptyText">
                      暂时没有可监控的流程！
                    </div>
                  }
                ></Result>
              </div>
            )}
          </ul>
        )}
      </div>
    </>
  );
};

export default Component;
